// Client-side IST date helpers. MUST agree with the server (functions/src/util.ts)
// so the month leaderboard filter matches what the scoring function writes.
// Asia/Kolkata has no DST, so a fixed offset makes YYYY-MM string math safe.
const istFmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Kolkata',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export function istDateString(d: Date = new Date()): string {
  return istFmt.format(d); // YYYY-MM-DD
}

export function istMonthKey(d: Date = new Date()): string {
  return istDateString(d).slice(0, 7); // YYYY-MM
}
